import React from 'react';
import './LocationCard.less';
import {LocationImage} from "elements/location-image/LocationImage";
import {LocationName} from "elements/location-name/LocationName";
import {LocationAddress} from "elements/location-address/LocationAddress";
import {LocationSchedule} from "elements/location-schedule/LocationSchedule";

export const LocationCard = ({name, address, schedule, image}) => {
	return <div className="location-card">
		<div className="location-card__container">
            <span className="location-card__name">
                <LocationName text={name}/>
            </span>
			<span className="location-card__address">
                <LocationAddress text={address}/>
            </span>
			<span className="location-card__schedule">
                <LocationSchedule text={schedule}/>
            </span>
		</div>
		<div className="location-card__image">
			<LocationImage src={image} visibleByDefault/>
		</div>
	</div>
}
